import { useQuery } from "@tanstack/react-query";
import { isUiMockMode } from "@/config/features";
import { MOCK_CUSTOMERS } from "@/fixtures/customers";
import { listAllCustomers } from "@/features/invoices/api/customers";
import { getAccountId } from "@/lib/auth/account";

export const customerKeys = {
  all: ["customers"] as const,
  list: (email?: string) => [...customerKeys.all, "list", email ?? ""] as const,
};

export function useCustomers(emailFilter?: string) {
  const accountReady = Boolean(getAccountId()?.startsWith("acct_"));
  const mock = isUiMockMode();

  return useQuery({
    queryKey: customerKeys.list(emailFilter),
    queryFn: () => {
      if (mock) {
        const q = emailFilter?.trim().toLowerCase();
        const items = q
          ? MOCK_CUSTOMERS.filter(
              (c) =>
                c.email?.toLowerCase().includes(q) ||
                c.name?.toLowerCase().includes(q),
            )
          : MOCK_CUSTOMERS;
        return Promise.resolve({
          items,
          has_more: false,
          next_cursor: null,
        });
      }
      return listAllCustomers({
        email: emailFilter?.trim() || undefined,
      });
    },
    enabled: mock || accountReady,
  });
}
